import { createRouter, createWebHistory } from 'vue-router';
import { ActivityContainer, DashboardContainer, ExportContainer, StudySettingsContainer, ArchiveContainer, FormContainer,
  DataContainer, UserManagementContainer, AccountSettingsContainer,
  OAuthStudyPagesContainer,
  SignUpContainer, StudyCreateContainer
} from '@/views';
import { FormBuilderContainer, CasesList, EntryList, Entry, PublicEntry } from '@/components';
import { useAuthStore } from '@/stores/auth';
import { routeConstants } from '@/utils';
import LoginContainer from '@/views/LoginContainer.vue';
import Onboarding from '@/components/login/onboarding/Onboarding.vue';
import AnalyticsContainer from '@/views/AnalyticsContainer.vue';
import SurgeonDashboardContainer from '@/views/SurgeonDashboardContainer.vue';
import InteractiveDashboard from '@/components/surgeon_dashboard/interactive/InteractiveDashboard.vue';
import { useFormBuilder } from '@/stores/formBuilder';
import { useEntryStore } from '@/stores/entry';
import { useEntryListStore } from '@/stores/entryList';
import PrintFormView from '@/components/forms/form_builder/print/PrintFormView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: routeConstants.ROOT.path,
      redirect: () => {
        return { path: routeConstants.DASHBOARD.path };
      }
    },
    {
      path: routeConstants.LOGIN.path,
      name: routeConstants.LOGIN.name,
      meta: { title: routeConstants.LOGIN.title },
      component: LoginContainer
    },
    {
      path: routeConstants.SIGNUP.path,
      name: routeConstants.SIGNUP.name,
      meta: { title: routeConstants.SIGNUP.title },
      component: SignUpContainer
    },
    {
      path: routeConstants.LOGOUT.path,
      name: routeConstants.LOGOUT.name,
      meta: { title: routeConstants.LOGOUT.title },
      component: () => import('@/components/login/Logout.vue')
    },   
    {
      path: routeConstants.STUDYPAGES_LOGIN_SUCCESS.path,
      name: routeConstants.STUDYPAGES_LOGIN_SUCCESS.name,
      meta: { title: routeConstants.STUDYPAGES_LOGIN_SUCCESS.title },
      component: OAuthStudyPagesContainer
    },
    {
      path: routeConstants.ONBOARDING.path,
      name: routeConstants.ONBOARDING.name,
      meta: { title: routeConstants.ONBOARDING.title },
      component: Onboarding
    },
    {
      path: routeConstants.STUDY_REDIRECT.path,
      name: routeConstants.STUDY_REDIRECT.name,
      meta: { title: routeConstants.STUDY_REDIRECT.title },
      component: OAuthStudyPagesContainer
    },
    {
      path: routeConstants.JOIN_STUDY.path,
      name: routeConstants.JOIN_STUDY.name,
      meta: { title: routeConstants.JOIN_STUDY.title },
      component: LoginContainer
    },
    {
      path: routeConstants.ECONSENT_VERIFICATION.path,
      name: routeConstants.ECONSENT_VERIFICATION.name,
      meta: { title: routeConstants.ECONSENT_VERIFICATION.title },
      component: OAuthStudyPagesContainer
    },
    {
      path: routeConstants.DASHBOARD.path,
      name: routeConstants.DASHBOARD.name,
      component: DashboardContainer,
      children: [
        {
          path: routeConstants.DATA.path,
          component: DataContainer,
          name: routeConstants.DATA.name,
          meta: { title: routeConstants.DATA.title },
          children: [
            {
              path: routeConstants.CASES.path,
              component: CasesList,
              name: routeConstants.CASES.name
            },
            {
              path: routeConstants.ENTRIES.path,
              component: CasesList,
              name: routeConstants.ENTRIES.name
            },
            {
              path: routeConstants.CASE.path,
              component: EntryList,
              name: routeConstants.CASE.name,
              meta: { title: routeConstants.CASE.title },
              children: [
                {
                  path: routeConstants.CASE_NEW_ENTRY.path,
                  component: Entry,
                  name: routeConstants.CASE_NEW_ENTRY.name
                },
                {
                  path: routeConstants.CASE_ENTRY.path,
                  component: Entry,
                  name: routeConstants.CASE_ENTRY.name
                }
              ]
            },
            {
              path: routeConstants.NEW_ENTRY.path,
              component: Entry,
              name: routeConstants.NEW_ENTRY.name
            },
            {
              path: routeConstants.ENTRY.path,
              component: Entry,
              name: routeConstants.ENTRY.name
            }
          ]
        },
        {
          path: routeConstants.FORMS.path,
          component: FormContainer,
          name: routeConstants.FORMS.name,
          meta: { title: routeConstants.FORMS.title }
        },
        {
          path: routeConstants.ARCHIVE.path,
          component: ArchiveContainer,
          name: routeConstants.ARCHIVE.name,
          meta: { title: routeConstants.ARCHIVE.title }
        },
        {
          path: routeConstants.ANALYTICS.path,
          component: AnalyticsContainer,
          name: routeConstants.ANALYTICS.name,
          meta: { title: routeConstants.ANALYTICS.title }
        },
        {
          path: routeConstants.SURGEON_DASHBOARD.path,
          component: SurgeonDashboardContainer,
          name: routeConstants.SURGEON_DASHBOARD.name,
          meta: { title: routeConstants.SURGEON_DASHBOARD.title },
          children: [
            {
              path: '',
              component: () => import('@/components/surgeon_dashboard/SurgeonDashboard.vue'),
              name: routeConstants.DEFAULT_SURGEON_DASHBOARD.name,
              meta: { title: routeConstants.SURGEON_DASHBOARD.title }
            },
            {
              path: routeConstants.CASE_SURGEON_DASHBOARD.path,
              component: () => import('@/components/surgeon_dashboard/SurgeonDashboard.vue'),
              name: routeConstants.CASE_SURGEON_DASHBOARD.name,
              meta: { title: routeConstants.SURGEON_DASHBOARD.title }
            },
            {
              path: routeConstants.INTERACTIVE_SURGEON_DASHBOARD.path,
              component: InteractiveDashboard,
              name: routeConstants.INTERACTIVE_SURGEON_DASHBOARD.name,
              meta: { title: routeConstants.INTERACTIVE_SURGEON_DASHBOARD.title }
            }
          ]
        },
        {
          path: routeConstants.FORM_BUILDER.path,
          component: FormBuilderContainer,
          name: routeConstants.FORM_BUILDER.name,
          meta: { title: routeConstants.FORM_BUILDER.title }
        },
        {
          path: routeConstants.EXPORT.path,
          component: ExportContainer,
          name: routeConstants.EXPORT.name,
          meta: { title: routeConstants.EXPORT.title }
        },
        {
          path: routeConstants.ACTIVITY.path,
          component: ActivityContainer,
          name: routeConstants.ACTIVITY.name,
          meta: { title: routeConstants.ACTIVITY.title }
        },
        {
          path: routeConstants.MANAGE.path,
          component: UserManagementContainer,
          name: routeConstants.MANAGE.name,
          meta: { title: routeConstants.MANAGE.title }
        },
        {
          path: routeConstants.STUDY_SETTINGS.path,
          component: StudySettingsContainer,
          name: routeConstants.STUDY_SETTINGS.name,
          meta: { title: routeConstants.STUDY_SETTINGS.title }
        },
        {
          path: routeConstants.ACCOUNT_SETTINGS.path,
          component: AccountSettingsContainer,
          name: routeConstants.ACCOUNT_SETTINGS.name,
          meta: { title: routeConstants.ACCOUNT_SETTINGS.title },
          children: [
            {
              path: routeConstants.PART_11_PIN_SETUP.path,
              component: StudySettingsContainer,
              name: routeConstants.PART_11_PIN_SETUP.name,
              meta: { title: routeConstants.PART_11_PIN_SETUP.title }
            }
          ]
        },
        {
          path: routeConstants.STUDY_CREATE.path,
          component: StudyCreateContainer,
          name: routeConstants.STUDY_CREATE.name,
          meta: { title: routeConstants.STUDY_CREATE.title }
        }
      ]
    },
    {
      path: routeConstants.PUBLIC_FORM.path,
      name: routeConstants.PUBLIC_FORM.name,
      component: PublicEntry
    },
    {
      path: routeConstants.PRINT_FORM.path,
      name: routeConstants.PRINT_FORM.name,
      component: PrintFormView
    },
    {
      path: routeConstants.MOBILE_AUTH.path,
      name: routeConstants.MOBILE_AUTH.name,
      component: () => import('@/components/login/mobile_auth/MobileAuth.vue')
      // component: MobileAuth
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => {
        window.location.href = 'https://teamscope.co/404';
        return null;
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const formBuilderStore = useFormBuilder();
  const entryStore = useEntryStore();
  const entryListStore = useEntryListStore();

  if (to.name === routeConstants.CASES.name) {
    // if users are on cases path, then they don't need the selected case
    entryListStore.selectedCase = undefined;
  }

  const isLeavingEntryPage = (
    (from.path.includes('/form/') || from.path.includes('/entry/')) &&
    !to.path.includes('/form/') &&
    !to.path.includes('/entry/')
  );
  if (isLeavingEntryPage && (entryStore.form || entryStore.entrySessionId)) {
    entryStore.sendEntryCloseEvent();
  }

  if (!entryStore.isEntryPristine) {
    entryStore.showDiscardChangesDialog()
      .then(() => next())
      .catch(() => next(false));
  } else if (!formBuilderStore.isFormPristine) {
    formBuilderStore.showDiscardChangesDialog()
      .then(() => next())
      .catch(() => next(false));
  } else {
    const authStore = useAuthStore();
    authStore.checkAuth();
    // the 2nd condition is for public form entry
    if (!authStore.userLoggedIn && !isUnauthRoute(to.fullPath)) {
      router.push({
        name: routeConstants.LOGIN.name
      });
    } else if (authStore.userLoggedIn) {
      if (to.name === routeConstants.LOGIN.name) {
        router.push({
          name: routeConstants.DASHBOARD.name
        });
      }
    }
    if (to.meta.title) {
      document.title = `${to.meta.title} | Studypages Data`;
    }
    next();
  }
});

const isUnauthRoute = (route: string) => {
  return route.startsWith('/form/') || 
    route.startsWith(routeConstants.LOGIN.path) ||
    route.startsWith(routeConstants.SIGNUP.path) ||
    route.startsWith('/studypages') ||
    route.startsWith('/investigation') ||
    route.startsWith(routeConstants.ECONSENT_VERIFICATION.path) ||
    route.startsWith(routeConstants.JOIN_STUDY.path) ||
    route.startsWith(routeConstants.MOBILE_AUTH.path);
};

export default router;
